import React, { useEffect } from "react";
import Auth_brand from "./Auth_brand";

const Forgot = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "/assets/js/elite.js?v=27";
    script.async = false;

    document.body.appendChild(script);

    return () => {
      script.remove();
    };
  }, []);
  return (
    <div>
      <section class="auth-page">
        <div class="auth-form-panel">
          <div class="auth-form-wrap">
            <header>
              <a href="/login" class="auth-logo" aria-label="KalpCargo home">
                <span class="auth-logo-mark">K</span>
                <span class="auth-logo-name">KalpCargo</span>
              </a>

              <div class="auth-heading">
                <h1 class="auth-title">Forgot your password?</h1>
                <p class="auth-subtitle">
                  Enter the email associated with your account and we'll send
                  you a code to reset it.
                </p>
              </div>
            </header>

            <form action="/forgot_otp" class="auth-form">
              <div class="auth-field">
                <label class="form-label" for="email">
                  Email address
                </label>
                <input
                  type="email"
                  class="form-control"
                  id="email"
                  name="email"
                  placeholder="you@company.com"
                  autocomplete="email"
                  autofocus
                  required
                />
              </div>

              <button type="submit" class="btn btn-primary auth-submit">
                <span class="auth-spinner" aria-hidden="true"></span>
                <span class="auth-submit-label">Reset Password</span>
                <i class="bi bi-arrow-right"></i>
              </button>
            </form>

            <p class="auth-signup">
              Remembered it? <a href="/login">Back to login</a>
            </p>
          </div>
        </div>

        <Auth_brand />
      </section>
    </div>
  );
};

export default Forgot;
